module.exports = __webpack_public_path__ + "static/img/icon54.97fe753.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon54.png
// module id = BS0k
// module chunks = 0